<template>
  <div>
    <Table :columns="columns1" :data="tableData"></Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  data() {
    return {
      reportId: null,
      tabVal: null,
      orgId: null,
      userId: null,
      tableData: [],
      columns1: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = JSON.parse(params.row.sellType);
            if (sellType.includes('1')) {
              return <span>网销产品</span>;
            } else if (sellType.includes('3')) {
              return <span>经代产品</span>;
            }
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 100
        },
        {
          title: '交费期',
          key: 'payLimit',
          align: 'center',
          render(h, params) {
            return <span>{params.row.payLimit ? params.row.payLimit + '年' : ''}</span>;
          },
          width: '100'
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            let commissionIndex = params.row.commissionIndex;
            return <span>{commissionIndex ? commissionIndex : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 120,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 120
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 120
        }
      ]
    };
  },
  created() {
    const { reportId, tabVal, orgId, userId } = this.$route.query;
    this.reportId = reportId;
    this.tabVal = tabVal;
    this.orgId = orgId;
    this.userId = userId;
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      let data = {
        reportId: this.reportId,
        owerType: '3',
        isRenewal: '0',
        commissionTypes: [1, 3, 7, 9],
        pageNo: this.pageNum,
        pageSize: this.pageSize
      };

      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$http({
        url: '/buz/userSettlementDetail/getDetail',
        type: 'POST',
        data
      })
        .then(res => {
          this.tableData = res.data.dataList && res.data.dataList.records;
          this.total = res.data.dataList.total;
          this.$emit('showTable', this.total == 0 ? false : true, 1);
        })
        .catch(e => {
          this.listLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
